/* eslint-disable */
import axios from 'axios';
import { authHeader } from '../helpers/authHeader';
const env = window.env;
function sanitizeInput(input, allowedKeys) {
    const result = {};
    if (!input || typeof input !== 'object') return result;
 
    for (const key of allowedKeys) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
            result[key] = input[key];
        }
    }
    return result;
}
 
function rejectDangerousKeys(input) {
    const blockedKeys = ['url', 'uri', 'endpoint', 'host', 'ip', 'link'];
    for (const key of Object.keys(input)) {
        if (blockedKeys.includes(key.toLowerCase())) {
            throw new Error(`Blocked potentially dangerous key: ${key}`);
        }
    }
}
export const messageTableServices = {
    get,
    post,
    unspscGet,
    unspscEnableCheck
};

function get(slug, params) {
    if (!slug) {
        return handleErrorResponse();
    }

    const requestConfig = {
        method: 'GET',
        url: `${env.BASE_API_URL}/admin/adminmessages`,
        params: params,
        headers: Object.assign({}, authHeader())
    };

    return axios(requestConfig)
        .then(response => handleResponse(response))
        .catch(error => handleErrorResponse(error));
}

function post(slug, data, params) {
    if (!slug) {
        return handleErrorResponse();
    }
    console.log('slug', slug, 'data', data, 'params', params)
    const requestConfig = {
        method: 'POST',
        url: `${env.BASE_API_URL}/admin/adminmessage`,
        data: data,
        params: params,
        headers: Object.assign({'Content-Type': 'application/json'}, authHeader())
    };
    console.log('requestConfig', requestConfig)
    return axios(requestConfig)
        .then(response => handleResponse(response))
        .catch(error => handleErrorResponse(error));
}

function unspscGet(params = {}, data = {}) {
    try {
        // Sanitize input to prevent SSRF-related keys
        rejectDangerousKeys(params);
        rejectDangerousKeys(data);
 
        const allowedParams = ['unspscId', 'level'];
        const allowedData = ['keyword'];
 
        const safeParams = sanitizeInput(params, allowedParams);
        const safeData = sanitizeInput(data, allowedData);
        console.log("safeParams", safeParams);
        console.log("safeData", safeData);
        const requestConfig = {
            method: 'POST',
            url: `${env.BASE_API_URL}/admin/unspsc/get${safeParams ? `?${safeParams}` : ""}`,
            data: safeData,
            headers: Object.assign({}, authHeader())
        };
 
        return axios(requestConfig)
            .then(response => handleResponse(response))
            .catch(error => handleErrorResponse(error));
    } catch (err) {
        return handleErrorResponse({ message: err.message });
    }
}

function unspscEnableCheck(data) {
    const requestConfig = {
        method: 'POST',
        url: `${env.BASE_API_URL}/admin/unspsc/enable/check`,
        data: data,
        headers: Object.assign({'Content-Type': 'application/json'}, authHeader())
    };

    return axios(requestConfig)
        .then(response => response)
        .catch(error => handleErrorResponse(error));
}

function handleResponse(response) {
    const data = response.data;

    if (data.length === 0) {
        return [];
    }

    return data;
}

function handleErrorResponse(error) {
    console.log(error); // eslint-disable-line
 
    if (!error) {
        return { error: 'Error: Unknown error', status: null };
    }
 
    if (error.response) {
        return {
            error: error.response.data.message || 'Error: Response error',
            status: error.response.status
        };
    }
 
    if (error.request) {
        return {
            error: 'Error: No response received from server',
            status: null
        };
    }
 
    return {
        error: error.message || 'Error: Unknown error occurred',
        status: null
    };
}
